'use client';

import normalize from 'styled-normalize';
import { theme } from '@frameio/vapor-theme';

export const GlobalStyle = () => {
  const globalStyleString = `
    ${normalize}

    * {
      box-sizing: border-box;
    }

    html {
      height: 100%;
      width: 100%;
    }

    ul {
      padding-left: 0;
      margin-top: 0;
      margin-bottom: 0;
    }

    body {
      -webkit-font-smoothing: antialiased;
      background: ${theme.colors.background.base};
      color: ${theme.colors.text.body};
      font-family: ${theme.fonts.body};
      font-synthesis: none;
      font-weight: ${theme.fontWeights.regular};
      height: 100%;
      margin: 0;
      overscroll-behavior-y: none;
      text-size-adjust: none;
      width: 100%;
    }

    a {
      text-decoration: none;
    }

    :root {
      font-feature-settings: 'liga' 1, 'calt' 1; /* Inter fix for Chrome */
    }
  `;
  // eslint-disable-next-line react/no-danger
  return <style dangerouslySetInnerHTML={{ __html: globalStyleString }} />;
};
